import React from 'react'
import { SpookySkeleton, SkeletonAvatar, SkeletonCard, SkeletonBox } from '@offerzen/pinata-shame'

import styles from './styles'

const SkeletonList = () => (
  <SpookySkeleton>
    <span className={styles.accessiblyHidden}>Loading</span>
    <div className={styles.list} aria-hidden="true">
      <For each="card" of={[0, 1]}>
        <SkeletonCard className={styles.card} key={card}>
          <SkeletonAvatar theme="dark" />
          <div>
            <SkeletonBox className={styles.heading} theme="dark" size="medium" />
            <SkeletonBox className={styles.heading} theme="dark" size="medium" />
          </div>
        </SkeletonCard>
      </For>
    </div>
  </SpookySkeleton>
)

export default SkeletonList
